<template>
  <div class="Card">
    <v-alert
      color="orange"
      dense
      outlined
      prominent
      dismissible
      text
      type="info"
      :value="error"
      @click="error = !error"
      >project temporarily disabled</v-alert
    >
    <div class="title">
      <p>{{ info.Title }}</p>
      <button
        @click="
          info.funcional == true
            ? $router.push({ path: `/project/${info.Title}` })
            : (error = true)
        "
      >
        <font-awesome-icon icon="arrow-right" class="icono" data-v-step="6" />
      </button>
    </div>
    <div class="description">
      <button
        @click="info.funcional == true ? (General = !General) : (error = true)"
        data-v-step="1"
      >
        General
      </button>
      <button
        @click="
          info.funcional == true ? (Location = !Location) : (error = true)
        "
      >
        Location
      </button>
      <button
        @click="
          info.funcional == true ? (Stadistics = !Stadistics) : (error = true)
        "
      >
        Statistics
      </button>
      <v-dialog v-model="Stadistics"
        ><stadistics v-on:close="toogle" name="Stadistics"
      /></v-dialog>
      <v-dialog width="600" v-model="General"
        ><CardInfo v-on:close="toogle"
      /></v-dialog>
      <v-dialog width="600" v-model="Location"
        ><Map
          v-if="Location"
          v-on:close="toogle"
          :show="Location"
          :lng="-67.613233"
          :lat="-38.045047"
          :zoom="9"
      /></v-dialog>
    </div>
    <div class="graphics">
      <div class="grafico1">
        <svg>
          <circle cx="50%" cy="40%" r="40"></circle>
          <circle cx="50%" cy="40%" r="40"></circle>
        </svg>
        <p class="Value">{{ info.PhasesSlopes }}/{{ info.PhasesDone }}</p>

        <p class="Nombre">
          Projects <br />
          Phases
        </p>
        <a class="aEscritorio" @click="ProjectPhases" data-v-step="2"></a>
        <a class="aMovil" v-on:click="ProjectPhasesMovil"></a>
        <div
          class="PhasesMovil"
          v-if="VarProjectPhasesMovil"
          style="margin-top: 5px"
        >
          <p v-if="!loading1">PHASE</p>
          <GChart
            style="margin-top: 5px"
            type="BarChart"
            :data="getProccesProyects.ChartPhases.chartData"
            :options="getProccesProyects.ChartPhases.chartOptions"
          />
          <div class="loading" v-if="loading1">
            <v-progress-circular
              v-if="loading1"
              style="
                text-align: center;
                width: 100%;
                z-idex: 5;
                margin-top: 5px;
              "
              indeterminate
              color="primary"
              class="PhasesMovil"
            ></v-progress-circular>
          </div>
        </div>
      </div>

      <div class="contenedorGraficos">
        <div class="titulo">
          <p>Consulting Hours</p>
        </div>
        <div class="otherGrafics">
          <div class="grafico2">
            <svg>
              <circle cx="50%" cy="30%" r="40"></circle>
              <circle cx="50%" cy="30%" r="40"></circle>
            </svg>
            <p class="Value2">{{ info.Contrated }}</p>
            <p class="Nombre2">Contracted</p>
          </div>
          <div class="grafico3">
            <svg>
              <circle cx="50%" cy="30%" r="40"></circle>
              <circle cx="50%" cy="30%" r="40"></circle>
            </svg>

            <p class="Value3">{{ info.DataAnalysis }}</p>
            <p class="Nombre3">
              Data <br />
              Analysis
            </p>
            <a v-on:click="FunctionDataAnalysis" data-v-step="3"></a>
          </div>
          <div class="grafico4">
            <svg>
              <circle cx="50%" cy="30%" r="40"></circle>
              <circle cx="50%" cy="30%" r="40"></circle>
            </svg>

            <p class="Value4">{{ info.PeerReview }}</p>
            <p class="Nombre4">
              Peer <br />
              Review
            </p>
            <a v-on:click="FunctionPeerReview"></a>
          </div>
        </div>
      </div>
    </div>

    <div class="PhasesEscritorio" v-if="VarProjectPhases">
      <p v-if="!loading2">PHASE</p>
      <GChart
        type="BarChart"
        :data="getProccesProyects.ChartPhases.chartData"
        :options="getProccesProyects.ChartPhases.chartOptions"
      />
      <div class="loading" v-if="loading2">
        <v-progress-circular
          v-if="loading2"
          style="width: 100%; text-align: center"
          indeterminate
          color="primary"
          class="PhasesEscritorio"
        ></v-progress-circular>
      </div>
    </div>

    <div class="ClassDataAnalysis" v-if="VarDataAnalysis">
      <GChart
        type="ColumnChart"
        :data="getProccesProyects.ChartDataAnalysis.chartData"
        :options="getProccesProyects.ChartDataAnalysis.chartOptions"
      />
      <p v-if="!loading3">PHASE</p>
      <div class="loading" v-if="loading3">
        <v-progress-circular
          v-if="loading3"
          style="width: 100%; text-align: center"
          indeterminate
          color="primary"
          class="ClassDataAnalysis"
        ></v-progress-circular>
      </div>
    </div>

    <div class="ClassPeerReview" v-if="VarPeerReview">
      <GChart
        type="ColumnChart"
        :data="getProccesProyects.ChartPeerReview.chartData"
        :options="getProccesProyects.ChartPeerReview.chartOptions"
      />
      <p v-if="!loading4">PHASE</p>
      <div class="loading" v-if="loading4">
        <v-progress-circular
          v-if="loading4"
          style="width: 100%; text-align: center"
          indeterminate
          color="primary"
          class="ClassPeerReview"
        ></v-progress-circular>
      </div>
    </div>

    <div class="footer">
      <div>
        <p class="Consultants" data-v-step="4">Consultants</p>
        <a v-on:click="Consultants"></a>
      </div>
      <p class="hours">{{ info.HoursRemaining }} hours remaining</p>
    </div>
    <ConsultantsComp :Consultores="info.Consultants" v-if="consultores" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { GChart } from "vue-google-charts";
import CardInfo from "../components/ProyectDetails/CardInfo";
import Map from "../components/ProyectDetails/Map";
import stadistics from "../components/ProyectDetails/stadistics";
import { mapGetters } from "vuex";
import ConsultantsComp from "../components/ViewProject/Consultants";
export default {
  data: () => ({
    consultores: false,
    VarProjectPhases: false,
    VarProjectPhasesMovil: false,
    VarDataAnalysis: false,
    VarPeerReview: false,
    General: false,
    Location: false,
    Stadistics: false,
    image: "../assets/persona1.jpg",
    Phases: "",
    Contrated: "",
    Data: "",
    Peer: "",
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    error: false,
  }),
  computed: {
    ...mapState(["projects"]),
    ...mapGetters(["getProccesProyects"]),
  },
  methods: {
    Consultants() {
      if (this.info.funcional) {
        this.consultores = !this.consultores;
      } else {
        this.error = true;
      }
    },
    ProjectPhases() {
      if (this.info.funcional) {
        this.loading2 = true;
        this.VarProjectPhases = !this.VarProjectPhases;
        setTimeout(() => {
          {
            this.loading2 = false;
          }
        }, 500);
        this.VarDataAnalysis = false;
        this.VarPeerReview = false;
        this.VarProjectPhasesMovil = false;
      } else {
        this.error = true;
      }
    },
    ProjectPhasesMovil() {
      if (this.info.funcional) {
        this.loading1 = true;
        this.VarProjectPhasesMovil = !this.VarProjectPhasesMovil;
        setTimeout(() => {
          {
            this.loading1 = false;
          }
        }, 500);
        this.VarDataAnalysis = false;
        this.VarPeerReview = false;
      } else {
        this.error = true;
      }
    },
    FunctionDataAnalysis() {
      if (this.info.funcional) {
        this.loading3 = true;
        this.VarDataAnalysis = !this.VarDataAnalysis;
        setTimeout(() => {
          {
            this.loading3 = false;
          }
        }, 500);
        this.VarPeerReview = false;
        this.VarProjectPhases = false;
        this.VarProjectPhasesMovil = false;
      } else {
        this.error = true;
      }
    },
    FunctionPeerReview() {
      if (this.info.funcional) {
        this.loading4 = true;
        this.VarPeerReview = !this.VarPeerReview;
        setTimeout(() => {
          {
            this.loading4 = false;
          }
        }, 500);
        this.VarDataAnalysis = false;
        this.VarProjectPhases = false;
        this.VarProjectPhasesMovil = false;
      } else {
        this.error = true;
      }
    },
    toogle(name) {
      this[name] = false;
    },
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  created() {
    var medidaPhases = this.info.PhasesSlopes / this.info.PhasesDone;
    this.Phases =
      "stroke-dashoffset: calc(400 - (300 * " + medidaPhases * 100 + ") / 100)";
    this.Contrated = "stroke-dashoffset: calc(400 - (270 * 100) / 90)";
    this.Data =
      "stroke-dashoffset: calc(400 - (270 * " +
      this.info.DataAnalysis +
      ") / " +
      this.info.Contrated +
      ")";
    this.Peer =
      "stroke-dashoffset: calc(400 - (270 * " +
      this.info.PeerReview +
      ") / " +
      this.info.Contrated +
      ")";
  },
  components: {
    GChart,
    CardInfo,
    Map,
    stadistics,
    ConsultantsComp,
  },

  mounted() {},
};
</script>
<style lang="css" scoped>
.aEscritorio {
  display: block;
}
.aMovil {
  display: none;
}
.Card {
  width: 600px;
  box-shadow: 0px 0px 15px 1px var(--twelveth-color);
  border-radius: 5px;
  margin: 10px;
  position: relative;
  line-height: auto !important;
}
.title {
  margin: 0px;
  padding: 0px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 23px;
  display: flex;
  width: 100%;
}
.title p {
  margin: 0;
  padding: 5px;
  width: 90%;
  text-align: left;
  margin-left: 20px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 25px;
}
.title button {
  width: 140px;
  background: none;
  box-shadow: 14px -6px 15px -8px grey;
  outline: none;
  border: none;
  position: relative;
  text-align: right;
  cursor: pointer;
  height: 55px;
}
.title button::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  right: 25px;
  left: 30px;
  bottom: 0;
  background: none;
  transform: skew(40deg);
  box-shadow: -15px 13px 10px -8px grey;
  border-radius: 0px;
}
.title button .icono {
  font-size: 40px;
  margin-right: 5px;
  color: var(--sixth-color);
  width: 80px;
}

.description {
  background: white;
  display: flex;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.description button {
  background: rgb(127, 174, 226, 0.6);
  margin-right: 15px;
  padding: 5px;
  position: relative;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  opacity: 0.9;
  width: 140px;
  outline: none;
}
.description button::before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: none;
  top: 0;
  left: 0;
  border-right: 5px solid transparent;
  border-left: 5px solid #fff;
  border-top: 5px solid #fff;
  border-bottom: 5px solid transparent;
}

.graphics {
  width: 100%;
  display: flex;
  justify-content: center;
}
.graphics p {
  margin: 0;
}
.graphics .grafico1 {
  border-top: 1px solid var(--twelveth-color);
  border-right: 1px solid var(--twelveth-color);
  position: relative;
  display: flex;
  justify-content: center;
  width: 25%;
  flex-direction: column;
  margin-top: 0px;
}
.graphics .grafico1 a {
  background: none;
  outline: none;
  border-radius: 0;
  border: none;
  width: 0;
  height: 0;
  border-top: 15px solid var(--sixth-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  position: absolute;
  top: 163px;
  left: 42%;
}

.grafico1 .Value {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  text-align: center;
  font-size: 25px;
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
}
.grafico1 .Nombre {
  position: absolute;
  top: 115px;
  left: 0px;
  right: 0px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}

.grafico1 svg {
  position: relative;
  margin-bottom: 10px;
  margin-top: -10px;
}
.grafico1 svg circle {
  fill: none;
  stroke-width: 5;
  stroke: var(--dark-third-color);
  stroke-dasharray: 390;
  stroke-dashoffset: 390;
  stroke-linecap: round;
}
.grafico1 svg circle:nth-child(1) {
  stroke-dashoffset: 0;
  stroke: #dcebf5;
}
.grafico1 svg circle:nth-child(2) {
  stroke-dashoffset: 0;
  stroke: var(--seventh-color);
}
.graphics .contenedorGraficos .grafico2 {
  position: relative;
  display: flex;
  justify-content: center;
  width: 33%;
}

.grafico2 .Value2 {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 15px;
  position: absolute;
  left: 0;
  right: 0;
  top: 30px;
  text-align: center;
  font-size: 25px;
}
.grafico2 .Nombre2 {
  position: absolute;
  top: 60%;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  left: 0;
  right: 0;
  text-align: center;
}
.box2 {
  position: relative;
  display: flex;
  justify-content: center;
}

.grafico2 svg {
  position: relative;
  margin-bottom: 10px;
}
.grafico2 svg circle {
  fill: none;
  stroke-width: 5;
  stroke: var(--dark-third-color);
  stroke-dasharray: 390;
  stroke-dashoffset: 390;
  stroke-linecap: round;
}
.grafico2 svg circle:nth-child(1) {
  stroke-dashoffset: 0;
  stroke: #dcebf5;
}
.grafico2 svg circle:nth-child(2) {
  stroke-dashoffset: 0;
  stroke: #22163e;
}
.graphics .contenedorGraficos .grafico3 {
  position: relative;
  position: relative;
  display: flex;
  justify-content: center;
  width: 33%;
}

.grafico3 .Value3 {
  text-align: center;
  font-size: 25px;
  position: absolute;
  left: 0;
  right: 0;
  top: 30px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.grafico3 .Nombre3 {
  text-align: center;
  position: absolute;
  top: 55%;
  left: 0;
  right: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}
.box3 {
  position: relative;
  display: flex;
  justify-content: center;
}

.grafico3 svg {
  position: relative;
  margin-bottom: 10px;
}
.grafico3 svg circle {
  fill: none;
  stroke-width: 5;
  stroke: var(--dark-third-color);
  stroke-dasharray: 390;
  stroke-dashoffset: 390;
  stroke-linecap: round;
}
.graphics .grafico3 a {
  background: none;
  outline: none;
  border-radius: 0;
  border: none;
  width: 0;
  height: 0;
  border-top: 15px solid var(--sixth-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  position: absolute;
  top: 87%;
  left: 42%;
}
.grafico3 svg circle:nth-child(1) {
  stroke-dashoffset: 0;
  stroke: #dcebf5;
}
.grafico3 svg circle:nth-child(2) {
  stroke-dashoffset: 220;
  stroke: var(--sixth-color);
}
.graphics .contenedorGraficos .grafico4 {
  position: relative;
  display: flex;
  justify-content: center;
  width: 34%;
}
.grafico4 .Value4 {
  text-align: center;
  font-size: 25px;
  position: absolute;
  left: 0;
  right: 0;
  top: 30px;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.grafico4 .Nombre4 {
  text-align: center;
  position: absolute;
  top: 55%;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  right: 0;
  left: 0;
  text-align: center;
}

.graphics .grafico4 a {
  background: none;
  outline: none;
  border-radius: 0;
  border: none;
  width: 0;
  height: 0;
  border-top: 15px solid var(--sixth-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  position: absolute;
  top: 87%;
  left: 42%;
}
.grafico4 svg {
  position: relative;
  margin-bottom: 10px;
}
.grafico4 svg circle {
  fill: none;
  stroke-width: 5;
  stroke: var(--dark-third-color);
  stroke-dasharray: 390;
  stroke-dashoffset: 390;
  stroke-linecap: round;
}
.grafico4 svg circle:nth-child(1) {
  stroke-dashoffset: 0;
  stroke: #dcebf5;
}
.grafico4 svg circle:nth-child(2) {
  stroke-dashoffset: 330;
  stroke: var(--seventh-color);
}
.contenedorGraficos {
  height: 100%;
  width: 75%; /*IMPORTANTE*/
}
.contenedorGraficos .titulo {
  color: var(--sixth-color);
  border-top: 1px solid var(--twelveth-color);
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
}
.otherGrafics {
  display: flex;
  flex-direction: row;
}
.PhasesEscritorio {
  position: relative;
  z-index: 1;
  position: relative;
}

.PhasesEscritorio p {
  position: absolute;
  top: 10px;
  z-index: 3;
  top: 45%;
  transform: rotate(270deg);
  left: 15px;
  font-family: Poppins, sans-serif;
  font-weight: bold;
  font-size: 12px;
}
.PhasesMovil {
  position: relative;
  z-index: 1;
  position: relative;
  display: none;
}
.PhasesMovil p {
  position: absolute;
  top: 10px;
  z-index: 2;
  top: 45%;
  transform: rotate(270deg);
  left: 15px;
  font-family: Poppins, sans-serif;
  font-weight: bold;
  font-size: 12px;
}
.ClassDataAnalysis {
  position: relative;
  z-index: 1;
  position: relative;
}
.ClassDataAnalysis P {
  font-family: Poppins, sans-serif;
  font-weight: bold;
  display: flex;
  justify-content: center;
  font-size: 12px;
}
.ClassPeerReview {
  position: relative;
  z-index: 1;
  position: relative;
}
.ClassPeerReview P {
  font-family: Poppins, sans-serif;
  font-weight: bold;
  display: flex;
  justify-content: center;
  font-size: 12px;
}
.footer {
  display: flex;
  justify-content: space-between;
  box-shadow: 0px -1px 5px 0px grey;
  align-items: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  position: relative;
  z-index: 3;
}
.footer div {
  display: flex;
  flex-direction: row;
  z-index: 3;
}
.footer .Consultants {
  margin: 10px;
  font-size: 28px;
  color: var(--dark-third-color);
  z-index: 1;
  position: relative;
}
.footer .hours {
  margin: 10px;
  font-size: 20px;
  color: var(--sixth-color);
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.footer a {
  background: none;
  outline: none;
  border-radius: 0;
  border: none;
  width: 0;
  height: 0;
  border-top: 15px solid var(--sixth-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  margin-top: 20px;
}

.loading {
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 50px;
  z-index: 5;
  background: white;
  position: absolute;
  top: 0px;
}
@media (max-width: 666px) {
  .aEscritorio {
    display: none;
  }
  .aMovil {
    display: block;
  }
  .Card {
    font-size: 12px;
    width: 400px;
  }
  .description {
    width: 100%;
    margin: 0;
  }
  .title button .icono {
    font-size: 35px;
    margin-left: 40px;
    color: var(--sixth-color);
    width: 80px;
  }
  .graphics {
    flex-direction: column;
  }
  .graphics .grafico1 {
    border-right: none;
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #c1c1c1;
    margin-bottom: 10px;
    margin-top: 0;
  }

  .grafico1 .Value {
    top: 43px;
  }
  .graphics .grafico1 .Nombre {
    left: 0;
    right: 0;
    text-align: center;
    margin-top: -10px;
  }
  .graphics .grafico1 a {
    left: 47%;
    right: 0;
    text-align: center;
    margin-top: -10px;
  }
  .graphics .contenedorGraficos {
    width: 100%;
  }
  .graphics .contenedorGraficos .titulo {
    border-top: none;
  }
  .PhasesEscritorio {
    display: none;
  }
  .PhasesMovil {
    display: block;
  }
  .footer .Consultants {
    font-size: 15px;
  }

  .footer .hours {
    font-size: 15px;
  }
  .description button {
    width: 80px;
  }
  .footer a {
    margin-top: 15px;
  }

  .graphics .grafico4 a {
    top: 85%;
  }
  .graphics .grafico3 a {
    top: 85%;
  }
  .title p {
    font-size: 20px;
  }
}
@media (max-width: 438px) {
  .Card {
    font-size: 12px;
    width: 350px;
  }
  .grafico1 svg circle {
    transform: scale(0.9, 0.9);
    transform-origin: 45% 45%;
  }
  .grafico2 svg circle {
    transform: scale(0.9, 0.9);
    transform-origin: 45% 45%;
  }
  .grafico3 svg circle {
    transform: scale(0.9, 0.9);
    transform-origin: 45% 45%;
  }
  .grafico4 svg circle {
    transform: scale(0.9, 0.9);
    transform-origin: 45% 45%;
  }
  .title button .icono {
    font-size: 35px;
    color: var(--sixth-color);
    width: 60px;
  }
}
@media (max-width: 374px) {
  .title p {
    font-size: 15px;
  }
  .Card {
    font-size: 12px;
    width: 300px;
  }
  .grafico1 svg {
    position: relative;
    margin-top: 0px;
  }
  .graphics .grafico1 .Nombre {
    top: 85px;
    margin-top: 0px;
  }
  .graphics .grafico1 a {
    top: 150px;
  }
  .grafico1 .Value {
    top: 27px;
    left: -3px;
  }
  .graphics .grafico1 {
    padding: 0;
  }
  .grafico1 svg circle {
    transform: scale(0.8, 0.8);
    transform-origin: 45% -10%;
  }
  .grafico2 svg circle {
    transform: scale(0.8, 0.8);
    transform-origin: 45% 45%;
  }
  .grafico3 svg circle {
    transform: scale(0.8, 0.8);
    transform-origin: 45% 45%;
  }
  .grafico4 svg circle {
    transform: scale(0.8, 0.8);
    transform-origin: 45% 45%;
  }
  .grafico4 .Value4 {
    transform: scale(0.7, 0.7);
    transform-origin: 50% 60%;
  }
  .grafico3 .Value3 {
    transform: scale(0.7, 0.7);
    transform-origin: 50% 60%;
  }
  .grafico2 .Value2 {
    transform: scale(0.7, 0.7);
    transform-origin: 50% 60%;
  }
  .grafico1 .Value1 {
    transform: scale(0.7, 0.7);
    transform-origin: 50% 60%;
  }
  .footer .hours {
    margin: 2px;
    font-size: 14px;
  }
}
</style>